import React from 'react';
import PropTypes from 'prop-types';
import { ShareFromSquare } from '../ui/icon/ShareFromSquare';
import { DownloadThin } from '../ui/icon/DownloadThin';
import { Link } from '../ui/icon/Link';

const defaultOptions = { showFileName: false, showDateUpdated: true, showFileSize: true };

function DocumentFileDownloadTable({
  documentFiles,
  product,
  options,
}) {
  const mergedOptions = { ...defaultOptions, ...(options || {}) };

  return (
    <div className="table-document">
      {documentFiles.map((documentFile) => (
        <div key={documentFile.id} className="table-document-row">
          <div className={(mergedOptions.showDateUpdated || mergedOptions.showFileSize) ? 'table-document-cell double cell-small-font' : 'cell-small-font'}>
            <a href={documentFile.url} target="_blank" rel="noreferrer">
              <DownloadThin />
              {mergedOptions.showFileName && documentFile.title}
              &nbsp;
              {documentFile.fileLanguage.join(', ')}
            </a>
          </div>
          {(mergedOptions.showDateUpdated || mergedOptions.showFileSize) && (
            <div className={`table-document-cell cell-small-font ${mergedOptions.showDateUpdated && mergedOptions.showFileSize && 'double'}`}>
              {mergedOptions.showDateUpdated && (
                <time dateTime={documentFile.dateUpdated}>{documentFile.dateUpdatedFormatted}</time>
              )}
              {mergedOptions.showFileSize && (<span>{`${documentFile.kind} (${documentFile.size})`}</span>)}
            </div>
          )}
          <div className="table-document-cell cell-small-font">
            <button className="btn-share dropdown-toggle" type="button" data-bs-toggle="dropdown" data-bs-auto-close="outside" aria-expanded="false">
              <ShareFromSquare />
              <span className="d-none d-md-inline">
                &nbsp;
                {Craft.t(product, 'Share')}
              </span>
            </button>
            <div className="drop-share dropdown-menu">
              <ul className="list-share">
                <li>
                  <button type="button" data-clipboard-text={documentFile.url}>
                    <Link />
                    <span>{Craft.t(product, 'Copy download link')}</span>
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

DocumentFileDownloadTable.propTypes = {
  documentFiles: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    url: PropTypes.string.isRequired,
    fileLanguage: PropTypes.arrayOf(PropTypes.string).isRequired,
    dateUpdated: PropTypes.string.isRequired,
    dateUpdatedFormatted: PropTypes.string.isRequired,
    kind: PropTypes.string.isRequired,
    size: PropTypes.string.isRequired,
  })).isRequired,
  product: PropTypes.object.isRequired,
  options: PropTypes.shape({
    showFileName: PropTypes.bool,
    showDateUpdated: PropTypes.bool,
    showFileSize: PropTypes.bool,
  }),
};

export { DocumentFileDownloadTable };
